const InfoCard = ({ name, value, list }) => {
  return (
    <div className={`card dashboard-stats-card`}>
      <div className="card-body">
        <div className="device-info-item">
          <div className="device-info-name">{name}</div>
          { value && (<div className="device-info-value">{value}</div>)}
          { list?.length > 0 && ( <ul> {list?.map((el, i) => (<li key={i}>{el}</li>))} </ul> )}
        </div>
      </div>
    </div>
  );
}

export default InfoCard;